import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const getDecodes = async (bu_id) => {
  $('#intype').text('');
  $('#intype').val(null);
  const typestructprov = $('#typestructprov');
  if (typestructprov.length > 0) {
    typestructprov.text('');
    typestructprov.val(null);
    typestructprov.trigger('change');
  }
  const url = `/${window.locale}/business_units/intypes_for_select?bu_id=${bu_id}`;
  Loader.show();
  try {
    const { data } = await apiConnector().get(url);
    $.each(data, function (i, item) {
      $('#intype').append(
        $('<option>', {
          value: item[1],
          text: item[0],
        }),
      );
    });
    if (typestructprov.length > 0) {
      const url2 = `/${window.locale}/business_units/typestructprovs_for_select?bu_id=${bu_id}`;
      const { data } = await apiConnector().get(url2);
      $.each(data, function (i, item) {
        typestructprov.append(
          $('<option>', {
            value: item[1],
            text: item[0],
          }),
        );
      });
    }
    Loader.hide();
  } catch {
    Loader.hide();
  }
};

const init = (data) => {
  $('#intype').text('');
  $('#intype').val(null);

  () => {
    return window.i18nJS;
  };

  try {
    $('#business_unit_struct').on('change', function () {
      const bu_id = $(this).val();
      if (bu_id) {
        getDecodes(bu_id);
      } else {
        $('#intype').text('');
        $('#intype').val(null);
      }

      $('#beds_config_id_select').removeClass('mychzn');
      $('#beds_config_id_select').removeClass('mychzn-obbligatorio');
      if (data[bu_id]) {
        $('#beds_config_id_select').addClass('mychzn-obbligatorio');
      } else {
        $('#beds_config_id_select').addClass('mychzn');
      }
    });
  } catch (e) {
    errorManager(e);
  }
};

window.SelectionDecodes = {
  init: init,
};
